export default __webpack_public_path__ + "static/media/commercial.bd79cf34.svg";